// GENERATED by scripts/bake-card-faces.mjs - do not edit by hand.
// Pre-baked card face assets (assets/cards/faces/<file>) for 60fps pack opening and high-res previews.
import { BALANCE_HASH } from './cards.js';

export const CARD_FACE_WIDTH = 465;
export const CARD_FACE_HEIGHT = 684;

export const CARD_FACES = new Set([
  "marine.webp",
  "tesla_walker.webp",
  "devil_patrol.webp",
  "hot_hand.webp",
  "pink_beret.webp",
  "hacker.webp",
  "wheelie_bomber.webp",
  "panzer.webp",
  "rocketship.webp",
  "deployable_cannon.webp",
  "shade.webp",
  "a9_piranha.webp",
  "a9_grizzly.webp",
  "a9_pigeon.webp",
  "fodder.webp",
  "reconsider.webp",
  "mental_extraction.webp",
  "invasion_capsule_sling.webp",
  "drone_command.webp",
  "congress_module.webp",
  "the_salvage_company.webp",
  "orchestra.webp",
  "stickman.webp",
  "defective_loaf.webp",
  "rejected_loaf.webp",
  "apostate_loaf.webp",
  "forgotten_loaf.webp",
  "delving_pillar.webp",
  "harvesting_pillar.webp",
  "processing_pillar.webp",
  "claiming_pillar.webp",
  "preserver_lock.webp",
  "sentinal_lock.webp",
  "bastion_lock.webp",
  "monitor_lock.webp",
  "enforcer_vulture.webp",
  "looting_vulture.webp",
  "parasite_vulture.webp",
  "anti_shade.webp",
  "forced_overstimulation.webp",
  "ambush.webp",
  "experimental_metamorphosis.webp",
  "precision_strike.webp",
  "retreat_protocol.webp",
  "pulp.webp",
  "marine_gold.webp",
  "tesla_walker_gold.webp",
  "devil_patrol_gold.webp",
  "hot_hand_gold.webp",
  "pink_beret_gold.webp",
  "hacker_gold.webp",
  "wheelie_bomber_gold.webp",
  "panzer_gold.webp",
  "rocketship_gold.webp",
  "deployable_cannon_gold.webp",
  "shade_gold.webp",
  "a9_piranha_gold.webp",
  "a9_grizzly_gold.webp",
  "a9_pigeon_gold.webp",
  "fodder_gold.webp",
  "reconsider_gold.webp",
  "mental_extraction_gold.webp",
  "invasion_capsule_sling_gold.webp",
  "drone_command_gold.webp",
  "congress_module_gold.webp",
  "the_salvage_company_gold.webp",
  "orchestra_gold.webp",
  "stickman_gold.webp",
  "defective_loaf_gold.webp",
  "rejected_loaf_gold.webp",
  "apostate_loaf_gold.webp",
  "forgotten_loaf_gold.webp",
  "delving_pillar_gold.webp",
  "harvesting_pillar_gold.webp",
  "processing_pillar_gold.webp",
  "claiming_pillar_gold.webp",
  "preserver_lock_gold.webp",
  "sentinal_lock_gold.webp",
  "bastion_lock_gold.webp",
  "monitor_lock_gold.webp",
  "enforcer_vulture_gold.webp",
  "looting_vulture_gold.webp",
  "parasite_vulture_gold.webp",
  "anti_shade_gold.webp",
  "forced_overstimulation_gold.webp",
  "ambush_gold.webp",
  "experimental_metamorphosis_gold.webp",
  "precision_strike_gold.webp",
  "retreat_protocol_gold.webp",
  "pulp_gold.webp",
  "hyper_marine_gold.webp",
  "hyper_shade_gold.webp",
  "hyper_devil_patrol_gold.webp",
  "hyper_tesla_walker_gold.webp",
  "hyper_panzer_gold.webp"
]);

export function getCardFaceKey(cardName, isGold = false) {
  if (!cardName) return null;
  let normalized = cardName;
  if (normalized === 'Black Marine') normalized = 'Marine';
  const safe = normalized.toLowerCase().replace(/[^a-z0-9]+/g, '_');
  const key = isGold ? `${safe}_gold.webp` : `${safe}.webp`;
  if (!CARD_FACES.has(key) && !isGold && safe.startsWith('hyper_')) {
    const baseSafe = safe.replace(/^hyper_/, '');
    if (CARD_FACES.has(`${baseSafe}.webp`)) {
      return `${baseSafe}.webp`;
    }
  }
  return key;
}

export function getCardFaceUrl(cardName, isGold = false) {
  const key = getCardFaceKey(cardName, isGold);
  if (key && CARD_FACES.has(key)) {
    return `assets/cards/faces/${key}?v=${BALANCE_HASH}`;
  }
  return null;
}
